module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/particular02-57c3b3320cd5e52d96264d8aad23c845.png";